import React, {memo} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AppSpinner from './AppSpinner';
import MiniGraph from "./MiniGraph";
import { cloudflareZonesAPI } from "../http-common";                                                    
import { cloudflareEventsAPI } from "../http-common";                                                   
import { Tooltip } from 'react-tooltip';
import '../styles/ProductOverviewWidget.css';
import '../styles/Cloudflare.css';
import 'react-tooltip/dist/react-tooltip.css';

import axios from "axios";

import { mauiServices } from "../http-common";                                                   



const CloudflareWidget = (props) => {
       
    /***
     *     __  ___      ___  ___  __  
     *    /__`  |   /\   |  |__  /__` 
     *    .__/  |  /~~\  |  |___ .__/ 
     *                                
     */

    const [cloudflareZones, setCloudflareZones] = React.useState();
    const [configMenuStatus, setConfigMenuStatus] = React.useState(false);   
    const [widgetOptions, setWidgetOptions] = React.useState(() => {
        
        let usedIndex = -1

        if(props.savedOptionsArray !== undefined){
            props.savedOptionsArray.forEach(function(widget, index) {
                
                if(widget.i !== undefined){
                    let string = widget.i
                    let subBefore= string.substring(0, string.indexOf('_'));
                    
                    if(subBefore === "cloudflarewidget"){
                        usedIndex = index;
                    } 
                }
            })
    
            let defaultTimerange = '30min'
    
            if(props.savedOptionsArray[usedIndex] !== undefined){
                defaultTimerange = props.savedOptionsArray[usedIndex].optionDefaultTimerange
            }
    
            let options = {
                i: props.id,            
                optionDefaultTimerange: defaultTimerange,
            };
    
            return options;
        } else {
            return '7d'
        }

    });    

    const [optionHasChanged, setOptionHasChanged] = React.useState(false)                                 
    const [isLoaded, setIsLoaded] = React.useState(false);                                       // Indikator ob Daten geladen wurden.       
    const [hasError, setHasError] = React.useState(false);                                      // Indikator ob Fehler vorliegen


  /***********************************************************************************************************
  /********************************************* DATENABRUF **************************************************
  /********************************************************************************************************** */  

const fetchZones = async () => {  
    setCloudflareZones([])

    const idToken = props.receiveIDToken();
    const headers = { 'Authorization': idToken };
    await cloudflareZonesAPI.get("", {headers})
    .then(response => {
  
      let obj = response.data;
      setCloudflareZones(obj)
      setIsLoaded(true)
      return obj
  
    })
    .catch(function (error) {
      console.log("Fetch error Zones" + error)
      setHasError(true)
      let obj = [];
      return (obj)
    });  
  }  


    /***
     *          __   ___     ___  ___  ___  ___  __  ___  __  
     *    |  | /__` |__     |__  |__  |__  |__  /  `  |  /__` 
     *    \__/ .__/ |___    |___ |    |    |___ \__,  |  .__/ 
     *                                                        
     */

    React.useEffect(() => {        
        fetchZones();
        //fetchMaui(); 
    }, []);


    React.useEffect(() => {        
        if(optionHasChanged === true){
            //console.log("Option has changed in Cloudflare")
            props.syncOptionsArray(props.id, widgetOptions)
            setOptionHasChanged(false)
            toggleConfigMenuStatus();
            fetchZones();
        } else {
            //console.log("No Option has been changed in Productoverview")
        }                
    }, [widgetOptions]);


    /***
     *     ___            __  ___    __        __  
     *    |__  |  | |\ | /  `  |  | /  \ |\ | /__` 
     *    |    \__/ | \| \__,  |  | \__/ | \| .__/ 
     *                                             
     */

     
    const toggleConfigMenuStatus = () => {
        setConfigMenuStatus(!configMenuStatus)
    }

    const toggleDefaultTimerange = (range) => {
        setOptionHasChanged(true)
        setWidgetOptions({ ...widgetOptions, optionDefaultTimerange: range });
    }

 
    /***********************************************************************************
     * DOM für das Konfigurationsmenü generieren 
     ***********************************************************************************/
    const FillConfigMenu = () => {
        const timeranges = [
            { key: '7d',  label: '7 Tage' },
            { key: '24h', label: '24 Stunden' },
            { key: '6h',  label: '6 Stunden' },
            { key: '30m', label: '30 Minuten' },
        ];
        const activeRange = widgetOptions.optionDefaultTimerange || '7d';

        return(
            <div className="productWidget--configMenuWrap productWidgetConfig--Card">
                <div className="productWidget--HeaderWrap drag-handle productWidgetConfig--Header">
                    <div className="productWidgetConfig--HeaderTextWrap">
                        <span className="productWidgetConfig--HeaderMeta">CLOUDFLARE FIREWALL</span>
                        <span className="productWidgetConfig--HeaderTitle">Widget-Konfiguration</span>
                    </div>
                    <button
                        type="button"
                        className="productWidgetHeader--MenuBtn productWidgetConfig--CloseBtn"
                        onClick={() => toggleConfigMenuStatus()}
                        aria-label="Konfiguration schließen"
                        title="Schließen"
                    >
                        <FontAwesomeIcon icon="fa-solid fa-xmark" />
                    </button>
                </div>
                <div className="productWidgetConfig--ContentWrap productWidgetConfig--Body">
                    <section className="productWidgetConfig--Section">
                        <div className="productWidgetConfig--SectionHead">
                            <div className="productWidgetConfig--SectionIcon" aria-hidden="true">
                                <FontAwesomeIcon icon="fa-solid fa-clock" />
                            </div>
                            <div className="productWidgetConfig--SectionTitle">Default-Zeitraum</div>
                        </div>
                        <div className="productWidgetConfig--SectionSubtitle">
                            Welcher Zeitraum wird beim Öffnen des Widgets initial angezeigt?
                        </div>
                        <div className="productWidgetConfig--Segmented" role="group" aria-label="Zeitraum auswählen">
                            {timeranges.map(tr => (
                                <button
                                    key={tr.key}
                                    type="button"
                                    className={"productWidgetConfig--SegmentedBtn" + (activeRange === tr.key ? " productWidgetConfig--SegmentedBtn--Active" : "")}
                                    onClick={() => toggleDefaultTimerange(tr.key)}
                                    aria-pressed={activeRange === tr.key}
                                >
                                    {tr.label}
                                </button>
                            ))}
                        </div>
                    </section>

                    <div className="productWidgetConfig--Note">
                        <FontAwesomeIcon icon="fa-solid fa-circle-info" />
                        <span>Änderungen werden erst mit dem nächsten Dashboard-Speichern dauerhaft übernommen.</span>
                    </div>
                </div>
                <div className="productWidgetConfig--DeleteWrap productWidgetConfig--Footer">
                    <button
                        type="button"
                        className="productWidgetHeader--DeleteBtn productWidgetConfig--DeleteBtn"
                        onClick={() => props.handleDelete(props.id)}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-trash" />
                        <span>Widget entfernen</span>
                    </button>
                </div>
            </div>
        )
    }


    /***
     *     __   __            __   ___ ___       __       
     *    |  \ /  \  |\/|    |__) |__   |  |  | |__) |\ | 
     *    |__/ \__/  |  |    |  \ |___  |  \__/ |  \ | \| 
     *                                                    
     */

    return(
        <>
            {configMenuStatus ?  <FillConfigMenu /> : null}
            <div className="productWidget--HeaderWrap drag-handle">
                <div className="productWidgetHeader--Title">Cloudflare Firewall - {widgetOptions.optionDefaultTimerange}</div>
                <button
                    className="cloudflareWidgetHeader--RefreshBtn"
                    onClick={() => fetchZones()}
                >
                    <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                </button>                
                <button
                    className="productWidgetHeader--MenuBtn"
                    onClick={() => toggleConfigMenuStatus()}
                >
                    <FontAwesomeIcon icon="fa-solid fa-ellipsis-vertical" />
                </button>
            </div>
            <div className="cloudflareWidget--ContentWrap">

            {
                (() => {
                    if (isLoaded === false)
                        return(
                            <div className="productWidget--LoadingWrap">
                                <p className="productWidget--LoadingWrapText">Lade Daten</p>
                                <p><AppSpinner /></p>
                            </div> 
                        )

                    if (hasError === true)
                        return <div className="productWidget--ErrorWrap">Error</div>
                    else 
                        return(
                            cloudflareZones.map((position) => {
                                return(
                                    <MiniGraph
                                        key={position.zoneTag}
                                        zoneTag={position.zoneTag}   
                                        name={position.name} 
                                        link={position.link} 
                                        timerange={widgetOptions.optionDefaultTimerange}
                                        receiveIDToken={props.receiveIDToken}
                                    ></MiniGraph>
                                )  
                            })
                        )
                })()
            }
            </div>
        </>
    )

}

export default memo(CloudflareWidget)
